import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  TextField,
} from "@material-ui/core";
import Loading from "../../components/Loading/Loading";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllRegisteredVendors } from "../../services/VendorServices";
import { updateProductOwnership } from "../../services/ProductService";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  dialog: {
    margin: theme.spacing(2.5)
  },
  textField: {
    display: 'flex',
    width: '100%'
  }
}));


export default function UpdateOwnership({ show, close, checkedItems, onSuccess }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { pending } = useSelector((state) => state.product);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loadingVendors, setLoadingVendors] = useState(false);

  const handleOptionSelected = (event, newValue) => {
    setSelectedOption(newValue);
  };

  useEffect(() => {
    if (!close) {
      return;
    }

    setSelectedOption(null);

    const fetchAllVendors = async () => {
      setLoadingVendors(true);
      try {
        const response = await getAllRegisteredVendors(dispatch);
        const vendorList = response.data.data || [];
        setOptions(
          vendorList.map((vendor) => ({
            label: vendor.business_name
              ? `${vendor.name} (${vendor.business_name})`
              : vendor.name,
            value: vendor.name,
            business_name: vendor.business_name,
            id: vendor.id,
          }))
        );
      } catch (error) {
        setOptions([]);
      }
      setLoadingVendors(false);
    };

    fetchAllVendors();
  }, [close, dispatch]);

  const handleUpdate = (event) => {
    event.preventDefault();
    if (selectedOption !== null && checkedItems.length > 0) {
      updateProductOwnership(selectedOption.id, checkedItems, dispatch, () => {
        show();
        if (onSuccess) {
          onSuccess();
        }
      });
    }
  };

  if (pending) {
    return <Loading />;
  }

  return (
    <div>
      <Dialog open={close} onClose={() => show()} className={classes.dialog}>
        <DialogTitle>Update Ownership</DialogTitle>
        <DialogContent>
          {loadingVendors ? (
            <Loading />
          ) : (
            <Autocomplete
              options={options}
              getOptionLabel={(option) => option.label || ""}
              getOptionSelected={(option, value) =>
                option.id === value.id
              }
              value={selectedOption}
              onChange={handleOptionSelected}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Vendor"
                  variant="outlined"
                  className={classes.textField}
                  fullWidth
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "off",
                  }}
                />
              )}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => show()}>Cancel</Button>
          <Button
            onClick={handleUpdate}
            variant="contained"
            color="primary"
            disabled={!selectedOption || checkedItems.length === 0}
          >
            Update Ownership
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
